<div [style.background-color]="color()" class="position-relative w-100 h-100"></div>
